var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"arrow flex flex-row items-center"},[_c('lenny',{staticClass:"w-12 h-12"}),_c('p',{staticClass:"text-white ml-4 font-subtitle text-xs inline"},[_vm._v("->")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }